/*
 * Build-time switches. `VITE_API_MOCK` defaults to on: the app runs against the in-browser mock of the cloud
 * API (src/api/mock) until the real API exists. `isMock` gates everything demo-only (demo accounts, mock
 * inbox, "Reset demo data", /dev/kit).
 */
export const isMock = import.meta.env.VITE_API_MOCK !== 'false'
export const isDev = import.meta.env.DEV
/** Base URL of the cloud API; empty means same origin. */
export const apiBase = (import.meta.env.VITE_API_BASE ?? '').replace(/\/+$/, '')
/** Dev-only tooling (the /dev/kit route) is available in dev builds and in mock builds. */
export const devToolsEnabled = isDev || isMock
